import { createAction } from '@reduxjs/toolkit';

const workspaceInitialise = createAction('workspace/initialise', (payload) => ({
  payload,
  meta: { arg: { workspaceId: payload.data.id } },
}));

export { workspaceInitialise };
